import { findingViewSectionType_Graph, findingViewType_Sections } from '@app/advisor-ui-shared';
import { currentTimeMillis, Day, exists, Hour, Minute, randomFromArray, randomNumber, Week } from '@nu-art/ts-common';
import { ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { valueType_Range, valueType_StandardRange } from '@app/hcs-shared';
const resolveDataFromValue = (value) => {
    switch (value?.type) {
        case valueType_Range: {
            const data = value.data;
            return { range: data.scope, measurementUnitId: data.unitsId };
        }
        case valueType_StandardRange: {
            const data = value.data;
            return { range: data.fullRange, measurementUnitId: data.unitsId };
        }
    }
};
const getResult = (range, prev, pair) => {
    const getVal = () => {
        const min = Math.floor(range[0] * 0.75);
        const max = Math.floor(range[1] * 1.25);
        return randomNumber([min, max]);
    };
    if (exists(pair))
        return { value: getVal(), currentVisit: pair.currentVisit, timestamp: pair.timestamp };
    const currentVisit = prev?.currentVisit === false ? false : randomFromArray([true, false, true, false, true]);
    const timestamp = currentVisit
        ? (exists(prev) ? prev.timestamp - randomNumber([30 * Minute, 2 * Hour]) : currentTimeMillis())
        : (exists(prev) ? prev.timestamp - randomNumber([Day, Week]) : currentTimeMillis() - randomNumber([Day, Week]));
    return {
        value: getVal(),
        currentVisit,
        timestamp,
    };
};
const getResults = (range, pairs) => {
    const arr = Array.from({ length: exists(pairs) ? pairs.length : randomNumber([4, 10]) });
    arr.forEach((_, i) => {
        const prev = i === 0 ? undefined : arr[i - 1];
        const pair = pairs?.[i];
        arr[i] = getResult(range, prev, pair);
    });
    return arr;
};
export const mockVitalResults = (findingView) => {
    const results = {};
    if (findingView?.type !== findingViewType_Sections)
        return results;
    findingView.sections.forEach(section => {
        if (section.type !== findingViewSectionType_Graph)
            return;
        section.data.variableIds.forEach((id, i) => {
            const variable = ModuleFE_Variable.cache.unique(id);
            const value = ModuleFE_Value.cache.unique(variable?.valueId);
            const data = resolveDataFromValue(value);
            if (!data)
                return;
            const pairs = !i ? undefined : results[section.data.variableIds[i - 1]];
            results[id] = {
                normalRange: data.range,
                measurementUnitId: data.measurementUnitId,
                results: getResults(data.range, pairs?.results),
            };
        });
    });
    return results;
};
//# sourceMappingURL=mock-results.js.map